import NavbarFilterTasks from "@/shared/components/organisms/NavbarFilterTasks";
import TableListTasks, {
  TasksPageProps,
} from "@/shared/components/organisms/TableListTasks";

const fakeTasks: TasksPageProps[] = [];

export const TaskPage = () => {
  return (
    <>
      <NavbarFilterTasks />
      <TableListTasks people={fakeTasks} />
    </>
  );
};
